import { render, staticRenderFns } from "./NpsmEditAppr.vue?vue&type=template&id=58e144d4&scoped=true&"
import script from "./NpsmEditAppr.vue?vue&type=script&lang=js&"
export * from "./NpsmEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e144d4",
  null
  
)

export default component.exports